export const EMAIL_TYPES = [
  { value: 'personal', text: 'Personal' },
  { value: 'work', text: 'Work' },
  { value: 'other', text: 'Other' },
];

export const PHONE_TYPES = [
  { value: 'mobile', text: 'Mobile' },
  { value: 'work', text: 'Work' },
  { value: 'home', text: 'Home' },
  { value: 'other', text: 'Other' },
];

export const DEFAULT_EMAIL_ENTRY = {
  emailAddress: '',
  emailType: 'personal',
  isPrimary: false,
};

export const DEFAULT_PHONE_ENTRY = {
  phoneNumber: '',
  phoneType: 'mobile',
  isPrimary: false,
};
